import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { memberIdentificationClient } from 'tradera/utils/http';
import { GtmService } from 'tradera/services/google-tagmanager/google-tagmanager-service';
import { selectPreferredLanguageCode } from 'tradera/state/language/selectors';
import { useTranslator } from 'tradera/lang/translate';

interface PayPalCreateSessionCommand {
    clientId: string;
    purpose: string;
    languageCodeIso2: string;
}

interface PayPalCreateSessionCommandResult {
    redirectUrl: string;
}

export const PayPal = ({
    purpose,
    setSelectedIdentificationIsLoading,
    signal,
}: {
    purpose: string;
    signal: AbortSignal;
    setSelectedIdentificationIsLoading: (value: boolean) => void;
}) => {
    const { t } = useTranslator();
    const [error, setError] = useState<boolean>();
    const preferredLanguageCode = useSelector(selectPreferredLanguageCode);

    useEffect(() => {
        GtmService.trackAction('PayPal', 'Start', 'Mobile');
        memberIdentificationClient
            .command<
                PayPalCreateSessionCommandResult,
                PayPalCreateSessionCommand
            >(
                'PayPalCreateSession',
                {
                    clientId: 'touchweb',
                    purpose: purpose,
                    languageCodeIso2: preferredLanguageCode,
                },
                { signal: signal },
            )
            .then((response) => {
                if (response == undefined) {
                    throw new Error('Response is undefined');
                }

                const { redirectUrl } = response;
                window.location.href = redirectUrl;
                return;
            })
            .catch((ex) => {
                if (axios.isCancel(ex)) {
                    return;
                }

                setSelectedIdentificationIsLoading(false);
                setError(true);
            });
    }, [
        preferredLanguageCode,
        purpose,
        setError,
        setSelectedIdentificationIsLoading,
        signal,
    ]);

    return error ? (
        <div className="text-center text-danger p-5 m-2">
            {t('international_identification_errorUnavailable')}
        </div>
    ) : null;
};
